import MemberDirectorySearchBlock from './MemberDirectorySearchBlock';

export default MemberDirectorySearchBlock;
